export default "__VITE_ASSET__BseDZCc$__"